const DataTableEmpty = ({ columns, actions, message }: any) => (
  <tbody>
    <tr>
      <td
        colSpan={columns.length + (actions ? 1 : 0)}
        className="text-gray-600 dark:text-gray-300 py-4 text-center"
      >
        {message}
      </td>
    </tr>
  </tbody>
);

export default DataTableEmpty;
